import React from "react";
import XLSX from "xlsx";
import moment from "moment";
import { Button, Card, Switch } from "antd";
import NotaFiscalTableRow from "./components/table_row";


export default class NotaFiscal extends React.Component {
  state = { jud: false };

  handleChange = e => {
    const files = e.target.files;
    if (files && files[0]) this.setState({ ...this.state, file: files[0] });
  };

  make_cols = refstr => {
    let o = [],
      C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i)
      o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
  };

  ExcelDateToJSDate = (serial) => {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;

    var total_seconds = Math.floor(86400 * fractional_day);

    var seconds = total_seconds % 60;

    total_seconds -= seconds;

    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
  }

  handleFile = async () => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = async e => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
        locale: "pt-BR"
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      let data = XLSX.utils.sheet_to_json(ws, {
        cellDates: true,
        dateNF: "YYYY-MM-DD",
        raw: true
      });
      //console.log(data);
      data.map(value => {
        //console.log(value["vencimento"])
        //const d = (value["vencimento"] - (25567 + 1)) * 86400 * 1000
        //value['vencimento'] = moment(d).format('YYYY-MM-DD')
        //console.log(value)
        //value[" DT. VENCIMENTO "] = moment(
        //  (value[" DT. VENCIMENTO "] - (25567 + 1)) * 86400 * 1000
        //).format("YYYY-MM-DD");
        //console.log(value)
        //value['Dt.Receb.'] = moment((value['Dt.Receb.'] - (25567 + 1)) * 86400 * 1000).format('YYYY-MM-DD')
      });
      let linhas = [];
      //console.log(data);
      this.setState({
        ...this.state,
        data: data,
        cols: this.make_cols(ws["!ref"])
      });
    };
    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  };

  onChange = (value) => {
    this.setState({
      ...this.state,
      jud: value
    })
  }

  render() {
    if ("data" in this.state) {
      return (
        <React.Fragment>
          <table className="acordoview__table">
            <thead>
              <th>Pasta</th>
              <th>NF</th>
              <th>Data Vencimento</th>
              <th>Valor Parcela</th>
              <th>Status</th>
            </thead>
            <tbody>
              {this.state.data.map(value => {

                return <NotaFiscalTableRow nf={value} judicial={this.state.jud} />;
              })}
            </tbody>
          </table>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <br />
          <Card title="Cadastro de Nota Fiscal">
            <div>
              Aqui você pode cadastrar nota fiscal através do uploade de uma
              planilha.
              <br />
              <br />
              Só é possível incluir nota fiscal em parcela que está paga.
              <br />
              <br />
              A parcela é localizada no sistema pelo número da pasta, data de
              vencimento e valor da parcela.
              <br />
              <br />
              <input type="file" id="file" onChange={this.handleChange} />
              <br />
              <br />
              Judicial: <Switch onChange={this.onChange} />
              <br />
              <br />
              <div>
                <Button type="primary" onClick={this.handleFile}>
                  Upload
                </Button>
              </div>
            </div>
          </Card>
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotaFiscal/index.js